import { Menu, styled, Typography } from "@mui/material";
import { MouseEvent, useEffect, useState } from "react";
import { Calendar } from "react-datepicker2";
import CalendarIcon from "assets/icons/CalendarIcon";
import { DateToString } from "components/Reports/DateFilter";

const InputWrapper = styled("div")(({ theme }) => ({
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "12px",
  height: "40px",
  width: "100%",
  border: "1px solid #C2D0E3",
  borderRadius: 6,
  cursor: "pointer",
}));

const InputContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

interface Props {
  name: string;
  label: string;
  defaultValue?: string | null;
  required?: boolean;
  isGregorian?: boolean;
  onchange: (date: any, name: string) => void;
  style?: {
    inputWrapper: React.CSSProperties;
  };
  className?: string
}

export default function DateInput({
  name,
  label,
  isGregorian,
  required,
  onchange,
  defaultValue,
  style,
  className
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [value, setValue] = useState<string | null | undefined>(defaultValue);

  useEffect(() => setValue(defaultValue), [defaultValue]);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (date: any) => {
    setValue(DateToString(date._d));
    onchange(date, name);
  };

  return (
    <InputContainer className={className}>
      {label && (
        <div className="p p-[0px 8px 12px 0px]" style={{ fontSize: 14, fontWeight: 400,  color: "#33383D" }}>
          {label}
          {required ? "*" : ""}
        </div>
      )}
      <InputWrapper style={style ? style.inputWrapper : {}} onClick={handleClick}>
        <CalendarIcon />
        <Typography variant="body2">{value}</Typography>
      </InputWrapper>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        sx={{ "& div": { "& ul": { paddingTop: 0, paddingBottom: 0 } } }}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        disableScrollLock
      >
        <Calendar
          isGregorian={String(isGregorian) === "true"}
          onChange={(date) => {
            handleChange(date);
            handleClose();
          }}
        />
      </Menu>
    </InputContainer>
  );
}
